import { render, staticRenderFns } from "./ownerExitRoomList.vue?vue&type=template&id=c0af74b2&scoped=true"
import script from "./ownerExitRoomList.vue?vue&type=script&lang=js"
export * from "./ownerExitRoomList.vue?vue&type=script&lang=js"
import style0 from "./ownerExitRoomList.vue?vue&type=style&index=0&id=c0af74b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af74b2",
  null
  
)

export default component.exports